import { createApiCall } from 'lib/base';

const DELETE_HOME_WIDGET_BANNER = 'DELETE_HOME_WIDGET_BANNER';

const deleteHomeWidgetBannerApi = createApiCall<{ id: string }>(
  DELETE_HOME_WIDGET_BANNER,
  ({ id }) => ({
    endpoint: `api/admin/home-widget-banners/${id}`,
    method: 'DELETE',
  })
);

export default deleteHomeWidgetBannerApi;
